import React from 'react';
import { supabase } from '../supabase';
import OffersSection from './OffersSection';
import NewProducts from './NewProducts';

const StoresLayout = ({ userEmail }) => {

  return (
    <>
      <div>
        <div>
            <OffersSection supabase={supabase} userEmail={userEmail} uploaderId={1} />
        </div>
        <div>
            <NewProducts supabase={supabase} userEmail={userEmail} uploaderId={2} />
        </div>
      </div>
    </>
  );
};

export default StoresLayout;